<ng-container *ngIf="text?.length > length && !open; else elseBlock">{{ text | slice : 0 : length }}...</ng-container>
<ng-template #elseBlock>{{ text }}</ng-template>

<div *ngIf="text?.length > length">
  <i class="pi cursor-pointer" [class.pi-chevron-down]="!open" [class.pi-chevron-up]="open" (click)="open = !open"></i>
</div>

